import { render, staticRenderFns } from "./experimentalScore.vue?vue&type=template&id=574c6af4&scoped=true&"
import script from "./experimentalScore.vue?vue&type=script&lang=js&"
export * from "./experimentalScore.vue?vue&type=script&lang=js&"
import style0 from "./experimentalScore.vue?vue&type=style&index=0&id=574c6af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c6af4",
  null
  
)

export default component.exports